import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerOpen } from "redux/actions/appActions";

const useStyles = makeStyles((theme) => ({
  root: {
    bottom: 0,
    position: "fixed",
    backgroundColor: "white",
    width: "inherit",
    zIndex: 200,
    borderTop: `1px solid ${theme.palette.divider}`,
    '&:hover':{
      backgroundColor: "white",
    }
  },
}));

const DrawerFooter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dscDrawerOpen } = useSelector((state) => state.appConfig);
  return (
    <>
      <ListItem style={{ visibility: "hidden", backgroundColor: 'white' }}>
        <ListItemText
          primaryTypographyProps={{ noWrap: true }}
          primary={"Collapse"}
        />
      </ListItem>
      <ListItem
        button
        onClick={() => dispatch(setDrawerOpen(!dscDrawerOpen))}
        className={classes.root}
      >
        <ListItemIcon>
          {dscDrawerOpen ? (
            <ChevronLeft fontSize="large" />
          ) : (
            <ChevronRight fontSize="large" />
          )}
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{ noWrap: true, color: "textSecondary" }}
          primary={"Collapse"}
        />
      </ListItem>
    </>
  );
};

export default DrawerFooter;
